import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MemberQRSection = ({ user, membershipData }) => {
  const [isQRVisible, setIsQRVisible] = useState(false);

  const qrCodeData = `MEMBER:${user?.id}:${membershipData?.memberNumber}`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrCodeData)}`;

  const handleToggleQR = () => {
    setIsQRVisible(!isQRVisible);
  };

  const handleSaveToWallet = () => {
    // Mock wallet integration
    alert('Membership card saved to wallet!');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center">
          <Icon name="CreditCard" size={20} color="white" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground">Member Card</h2>
          <p className="text-sm text-muted-foreground">Your digital membership for rewards</p>
        </div>
      </div>
      {/* Membership Card Design */}
      <div className="bg-gradient-to-r from-primary to-accent rounded-lg p-6 text-white mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
              <Icon name="Ticket" size={20} color="white" />
            </div>
            <span className="text-lg font-semibold">Tixful</span>
          </div>
          <div className="text-right">
            <p className="text-xs opacity-80">Member Since</p>
            <p className="text-sm font-medium">{membershipData?.joinDate}</p>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-2xl font-bold">{user?.name}</p>
          <p className="text-sm opacity-90">Member #{membershipData?.memberNumber}</p>
          <p className="text-xs opacity-80">{membershipData?.tier} Member</p>
        </div>

        <div className="flex items-center justify-between mt-6">
          <div>
            <p className="text-xs opacity-80">Points Balance</p>
            <p className="text-xl font-bold">{membershipData?.points?.toLocaleString()}</p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleToggleQR}
            className="text-white hover:bg-white/20"
            iconName={isQRVisible ? "EyeOff" : "QrCode"}
          >
            {isQRVisible ? 'Hide QR' : 'Show QR'}
          </Button>
        </div>
      </div>
      {/* QR Code Display */}
      {isQRVisible && (
        <div className="bg-white rounded-lg p-6 text-center border border-border mb-6">
          <div className="inline-block p-4 bg-white rounded-lg shadow-elevation-2">
            <img
              src={qrCodeUrl}
              alt="Member QR Code"
              className="w-48 h-48 mx-auto"
            />
          </div>
          <p className="text-sm text-muted-foreground mt-4 mb-4">
            Show this QR code at participating venues to earn points
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="outline"
              size="sm"
              iconName="Wallet"
              onClick={handleSaveToWallet}
            >
              Save to Wallet
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Share"
            >
              Share
            </Button>
          </div>
        </div>
      )}
      {/* Usage Instructions */}
      <div className="bg-muted rounded-lg p-4">
        <h3 className="text-sm font-medium text-foreground mb-2">How to Use Your Member Card</h3>
        <ul className="text-xs text-muted-foreground space-y-1">
          <li>• Present QR code at venue check-in to earn points</li>
          <li>• Earn 1 point per $1 spent on tickets and merchandise</li>
          <li>• Redeem points for discounts and exclusive perks</li>
          <li>• {membershipData?.tier} members get {membershipData?.multiplier}x points</li>
        </ul>
      </div>
    </div>
  );
};

export default MemberQRSection;